export default "__VITE_ASSET__857eb1b5__"